//Dependencies
import React from 'react';
import { Link } from 'react-router-dom';
import ProgressiveImage from 'react-progressive-graceful-image';

/* BOTONES DE PORTAFOLIO */
const Thumbnail02 = (props) =>
{
  const { biz, text, image, placeholder, width } = props;


  return(
    <Link
      className = {'border border-solid border-black cursor-pointer'}      
      style     = {{width : width, height : width}}
      target    = "_blank" 
      to        = {`/${biz}`}
    >
      <ProgressiveImage 
        src = {image} 
        placeholder = {placeholder}
      >
        {(src) => {
          return (
            <img 
                className = "progressive-image object-cover" 
                src = {src} 
                style = 
                {{ 
                  height: '80%', 
                  width: '100%', 
                }} 
                alt = {biz}
              />
          );
        }}
      </ProgressiveImage>
      
      <div
        className = "flex border-t border-solid border-black justify-center bg-sky-500 items-center"
        style = 
        {{ 
          height: '20%', 
          width: '100%', 
        }}   
      >
        <h2
          className = "m-0 p-0 flex justify-center text-xs md:text-xs lg:text-base  font-bold uppercase items-center	text-white"
        >          
          {text.toUpperCase()}
        </h2>    
      </div>
    </Link>
  );
}

export default Thumbnail02;